import React from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { Retry } from '@components/common';
import { TableWrapper } from './styled';
import SubscriberTable from './SubscriberTable';
import useFetchData from './useFetchData';

function Table() {
  const { isIdle, status, data, refetch } = useFetchData();

  // Combine pages and show row data
  const rows: any[] = [];

  if (data) {
    data.pages.forEach((page) => {
      const records: any[] = get(page, ['data', 'data'], []);
      rows.push(...records);
    });
  }

  return (
    <TableWrapper>
      <Retry
        isLoading={status === 'loading' || isIdle}
        showError={status === 'error'}
        isEmpty={isEmpty(rows)}
        mountChildAlways={false}
        fetchData={refetch}
      >
        <SubscriberTable sessionData={rows} />
      </Retry>
    </TableWrapper>
  );
}

export default React.memo(Table);
